import {computed,ref,watch,onUpdated} from 'vue'
import {useStore} from 'vuex'
import deBounce from '../../foundation/js/deBounce'
import ProductSpot from '../ProductSpot/ProductSpot.vue'

const searchNow = deBounce((store,searchString)=>{
    if(searchString.length > 2){
        store.dispatch('productSearch/performQuickSearch',{
            searchString: searchString
        })
        return false
    }
    store.commit('productSearch/set_quick_search_results',[])
    store.commit('productSearch/set_quick_search_result_max_count',0)
},400)

export default {
    name: 'SiteNavigationSearchMenu',
    components:{
        ProductSpot
    },
    setup() {
        const store = useStore()
        const showSearchMenu = computed(()=>store.state.main.search_menu_open)
        const results = computed(()=>store.state.productSearch.quick_search_results)
        const totalResultCount = computed(()=>store.state.productSearch.quick_search_result_max_count)
        const searchUrl = computed(()=>`${store.state.main.search_page_url}${store.getters['productSearch/urlSearchString']}`)
        const searchString = ref('')
        const focusTarget = ref(null)

        const hideSearchMenu = function(){

            store.commit("main/close_search_menu")
            store.commit('main/hide_overlay')
            store.commit('productSearch/set_quick_search_results',[])
            store.commit('productSearch/set_search_string','')
            store.commit('productSearch/set_quick_search_result_max_count',0)
            searchString.value = ''
        }

        const clearSearch = function(){
            store.commit('productSearch/set_search_string','')
            store.commit('productSearch/set_quick_search_result_max_count',0)
            store.commit('productSearch/set_quick_search_results',[])
            searchString.value = ''
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const goToSearchPage = () => {
            store.commit('productSearch/set_search_string',searchString)
            location.href = store.state.main.search_page_url + store.getters['productSearch/urlSearchString']
        }

        watch(searchString,(newString)=>{
            searchNow(store,newString)
        })

        onUpdated(()=>{
            if(showSearchMenu.value) focusTarget.value.focus()
        })

        return {
            showSearchMenu,
            searchString,
            results,
            hideSearchMenu,
            getLabel,
            clearSearch,
            totalResultCount,
            searchUrl,
            goToSearchPage,
            focusTarget
        }
    },
}
